import React from 'react';

import { SvgIcon } from './SvgIcon';

interface IconProps {
  className?: string;
}

const OrderCollectionLarge = (props: IconProps): JSX.Element => (
  <SvgIcon className={props.className} enclosed size="l" viewBox="0 0 48 48">
    <path
      d="M32.7 13.9v-3.7a8.7 8.7 0 10-17.4 0v3.7H5V45h38V13.9H32.7zm-14.4-3.7a5.7 5.7 0 1111.4 0v3.7H18.3v-3.7zM40 42H8V16.9h7.3v2.5a1.5 1.5 0 103 0v-2.5h11.4v2.5a1.5 1.5 0 103 0v-2.5H40V42z"
      fill="#000"
    />
  </SvgIcon>
);

export default OrderCollectionLarge;
